export const media = {
    batchSize: 20,
    threshold: 15,
    jumpStep: 10,
    debounceWait: 200,
}
